export const TelegramSocketEvent = Object.freeze({
    // Sending events
    TELEGRAM_FORM_STATUS: 'telegramFormStatus',
    VERIFY_PHONE_NUMBER: 'verifyPhoneNumber',
    VERIFY_OTP: 'verifyOTP',
    BOT_CREATION: 'botCreation',
    GROUP_CREATION: 'groupCreation',
    DELETE_USER_SESSION: 'deleteUserSession',

    // Receiving events
    TELEGRAM_FORM_STATUS_UPDATE: 'telegramFormStatusUpdate',
    GET_OTP: 'getOTP',
    TELEGRAM_FORM_ERROR: 'telegramFormError',
});
